import { render, staticRenderFns } from "./TestQuestionItem.vue?vue&type=template&id=a1daa924&scoped=true&"
import script from "./TestQuestionItem.vue?vue&type=script&lang=js&"
export * from "./TestQuestionItem.vue?vue&type=script&lang=js&"
import style0 from "./TestQuestionItem.vue?vue&type=style&index=0&id=a1daa924&prod&lang=css&"
import style1 from "./TestQuestionItem.vue?vue&type=style&index=1&id=a1daa924&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1daa924",
  null
  
)

export default component.exports